import { render, staticRenderFns } from "./TabCitizens.vue?vue&type=template&id=1221c8d8&scoped=true"
import script from "./TabCitizens.vue?vue&type=script&lang=js"
export * from "./TabCitizens.vue?vue&type=script&lang=js"
import style0 from "./TabCitizens.vue?vue&type=style&index=0&id=1221c8d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1221c8d8",
  null
  
)

export default component.exports